import React, { useState, useRef } from "react";
import PropTypes from "prop-types";
import { useSearchToolbarContext } from "./hooks";
import "./DisplayMode.scss";
import { defaults } from "sanitize-html";

export const DISPLAYMODE = {
    GRIDCOMPACT: 'grid-compact',
    GRIDEXPANDED: 'grid-expanded',
    LIST: 'list',
  };

function DisplayMode() {
    const {
        displaymode: {
            option1 = { value: "", label: "", className: "" },
            option2 = { value: "", label: "", className: "" },
            option3 = { value: "", label: "", className: "" },
            defaultSelected,
            label,
            name,
            ariaLabel,
            onChange,
            hidden = false,
        },
    } = useSearchToolbarContext();

    const validDefaultSelected = [option1.value, option2.value, option3.value].includes(defaultSelected)? defaultSelected: option1.value;
    const [selected, setSelected] = useState(validDefaultSelected);

    // Add refs for each input
    const input1Ref = useRef();
    const input2Ref = useRef();
    const input3Ref = useRef();

    React.useEffect(() => {
        setSelected(validDefaultSelected);
        handleToggle(validDefaultSelected);
    }, [validDefaultSelected]);

    const handleToggle = (option) => {
        setSelected(option);
        if (onChange) onChange(option);
    };

    return !hidden && (
        <div>
            <fieldset
                aria-label={ariaLabel}
                role="radiogroup"
                className="toggle-icon-switch"
            >
                {label && <label className="toggle-icon-switch__label-text">{label}:</label>}
                <div className="toggle-icon-switch__options-wrapper">
                    <label
                        htmlFor={option1.value}
                        className={`toggle-icon-switch__option-label ${selected === option1.value ? "selected" : ""}`}
                        data-tooltip={option1.label}
                        onMouseLeave={() => {
                            if (input1Ref.current) input1Ref.current.blur();
                        }}
                    >
                        <input
                            ref={input1Ref}
                            type="radio"
                            id={option1.value}
                            name={name}
                            value={option1.value}
                            title={option1.label}
                            data-tooltip={option1.label}
                            checked={selected === option1.value}
                            onChange={() => handleToggle(option1.value)}
                            aria-checked={selected === option1.value}
                            onMouseUp={e => e.currentTarget.blur()}
                            onBlur={e => e.currentTarget.blur()}
                        />
                        <span className={option1.className} aria-hidden="true"></span>
                    </label>
                    <label
                        htmlFor={option2.value}
                        className={`toggle-icon-switch__option-label ${selected === option2.value ? "selected" : ""}`}
                        data-tooltip={option2.label}
                        onMouseLeave={() => {
                            if (input2Ref.current) input2Ref.current.blur();
                        }}
                    >
                        <input
                            ref={input2Ref}
                            type="radio"
                            id={option2.value}
                            name={name}
                            value={option2.value}
                            title={option2.label}
                            checked={selected === option2.value}
                            onChange={() => handleToggle(option2.value)}
                            aria-checked={selected === option2.value}
                            onMouseUp={e => e.currentTarget.blur()}
                            onBlur={e => e.currentTarget.blur()}
                        />
                        <span className={option2.className} aria-hidden="true"></span>
                    </label>
                    {option3.value && (
                        <label
                            htmlFor={option3.value}
                            className={`toggle-icon-switch__option-label ${selected === option3.value ? "selected" : ""}`}
                            data-tooltip={option3.label}
                            onMouseLeave={() => {
                                if (input3Ref.current) input3Ref.current.blur();
                            }}
                        >
                            <input
                                ref={input3Ref}
                                type="radio"
                                id={option3.value}
                                name={name}
                                value={option3.value}
                                title={option3.label}
                                checked={selected === option3.value}
                                onChange={() => handleToggle(option3.value)}
                                aria-checked={selected === option3.value}
                                onMouseUp={e => e.currentTarget.blur()}
                                onBlur={e => e.currentTarget.blur()}
                            />
                            <span className={option3.className} aria-hidden="true"></span>
                        </label>
                    )}
                </div>
            </fieldset>
        </div>
    );
}

export default DisplayMode;